import { Grid, Paper } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

export default function OnboardLayout(props) {


  return (
    <Grid container justifyContent={'center'}>
      <Grid
        id="onboardLayout-grid-item"
        item
        xs={10}
        sm={6}
        md={4}
        lg={4}
        xl={3}
        // component={Paper}
        // elevation={1}
        sx={{
          minHeight: "30vh",
          // backgroundColor:'#F0F7FC',
        }}
      >
        <Box
          id="onboardLayout-box1"
        >
          {props.children}
        </Box>
      </Grid>
    </Grid>
  )
}
